import classNames from "classnames";
import styles from "./today-button.module.css";
import { Button } from "@mui/material";

export interface TodayButtonProps {
  isEnabled: boolean;
  onButtonClick(): void;

  t: any;
}

export function TodayButton(props: any) {
  const { isEnabled, onButtonClick, t } = props;

  return (
    <div
      className={classNames(styles["today"], {
        [styles["available"]]: isEnabled,
      })}
    >
      <Button
        disabled={!isEnabled}
        onClick={() => {
          if (isEnabled) onButtonClick();
        }}
        fullWidth
        variant="contained"
        sx={{ minWidth: 0 }}
      >
        {t("Today")}
      </Button>
    </div>
  );
}
